import { px, rect, aRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const weapons: Record<string, Part> = {
  weapon_cannon: {
    id: 'weapon_cannon',
    category: 'weapon',
    name: 'Cannon',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -4 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 4, 2, 5, p.metalDark); aRect(ctx, a.x, a.y - 4, 2, 1, p.metal); px(ctx, a.x - 1, a.y - 3, p.metalLight); },
  },
  weapon_twin: {
    id: 'weapon_twin',
    category: 'weapon',
    name: 'Twin',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -4 } },
    draw: (ctx, a, p) => { rect(ctx, a.x - 2, a.y - 4, 1, 5, p.metalDark); rect(ctx, a.x + 1, a.y - 4, 1, 5, p.metalDark); aRect(ctx, a.x, a.y - 1, 2, 1, p.metal); aRect(ctx, a.x, a.y - 4, 2, 1, p.metalLight); },
  },
  weapon_laser: {
    id: 'weapon_laser',
    category: 'weapon',
    name: 'Laser',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -5 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 5, 2, 6, p.metal); aRect(ctx, a.x, a.y - 5, 2, 1, p.accent); aRect(ctx, a.x, a.y - 3, 2, 1, p.accent); aRect(ctx, a.x, a.y, 2, 1, p.metalDark); },
  },
  weapon_pod: {
    id: 'weapon_pod',
    category: 'weapon',
    name: 'Missile Pod',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -3 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 3, 4, 4, p.metalDark); aRect(ctx, a.x, a.y - 3, 4, 1, p.metal); rect(ctx, a.x - 2, a.y - 2, 1, 2, p.accent); rect(ctx, a.x + 1, a.y - 2, 1, 2, p.accent); },
  },
  weapon_gatling: {
    id: 'weapon_gatling',
    category: 'weapon',
    name: 'Gatling',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -4 } },
    draw: (ctx, a, p) => { rect(ctx, a.x - 2, a.y - 4, 1, 4, p.metalDark); aRect(ctx, a.x, a.y - 4, 2, 4, p.metal); rect(ctx, a.x + 1, a.y - 4, 1, 4, p.metalDark); aRect(ctx, a.x, a.y, 4, 1, p.metalDark); aRect(ctx, a.x, a.y - 4, 4, 1, p.metalDark); },
  },
  weapon_beam: {
    id: 'weapon_beam',
    category: 'weapon',
    name: 'Beam',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -5 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 5, 4, 6, p.metalDark); aRect(ctx, a.x, a.y - 5, 4, 1, p.metal); aRect(ctx, a.x, a.y - 4, 2, 4, p.accent); aRect(ctx, a.x, a.y, 4, 1, p.dark); },
  },
  weapon_railgun: {
    id: 'weapon_railgun',
    category: 'weapon',
    name: 'Railgun',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -6 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 6, 2, 7, p.metal); rect(ctx, a.x - 2, a.y - 5, 1, 5, p.metalDark); rect(ctx, a.x + 1, a.y - 5, 1, 5, p.metalDark); aRect(ctx, a.x, a.y - 6, 2, 1, p.accent); aRect(ctx, a.x, a.y - 3, 2, 1, p.accent); },
  },
  weapon_plasma: {
    id: 'weapon_plasma',
    category: 'weapon',
    name: 'Plasma',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -4 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 4, 4, 5, p.metalDark); aRect(ctx, a.x, a.y - 4, 4, 1, p.metal); aRect(ctx, a.x, a.y - 2, 2, 2, p.accent); aRect(ctx, a.x, a.y, 4, 1, p.dark); },
  },
  weapon_torpedo: {
    id: 'weapon_torpedo',
    category: 'weapon',
    name: 'Torpedo',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -5 } },
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 5, 2, 6, p.metalDark); aRect(ctx, a.x, a.y - 5, 2, 1, p.accent); aRect(ctx, a.x, a.y - 4, 2, 1, p.metal); px(ctx, a.x - 2, a.y - 3, p.metalDark); px(ctx, a.x + 1, a.y - 3, p.metalDark); px(ctx, a.x - 2, a.y - 2, p.metalDark); px(ctx, a.x + 1, a.y - 2, p.metalDark); },
  },
  weapon_burst: {
    id: 'weapon_burst',
    category: 'weapon',
    name: 'Burst',
    requires: SLOT.WEAPON_TOP,
    provides: { [SLOT.MUZZLE_TOP]: { baseSlot: SLOT.WEAPON_TOP, offsetY: -3 } },
    draw: (ctx, a, p) => { rect(ctx, a.x - 3, a.y - 3, 1, 4, p.metalDark); rect(ctx, a.x + 2, a.y - 3, 1, 4, p.metalDark); aRect(ctx, a.x, a.y - 3, 4, 4, p.metalDark); aRect(ctx, a.x, a.y - 3, 4, 1, p.metal); aRect(ctx, a.x, a.y - 1, 4, 1, p.accent); aRect(ctx, a.x, a.y, 4, 1, p.dark); },
  },
};
